import React from 'react';
import {Modal, List, InputItem, Icon, Toast} from 'antd-mobile';
import './NearModal.less';

const Brief = List.Item.Brief;

class NearLocation extends React.Component{
    constructor(props){
        super(props);
        
        this.state = {
            loadUI: false,
            amapAvailable: false
        }
    }
    componentDidMount(){
        this.onRefresh();
    }
    onRefresh() {
        Toast.loading($st('定位中...'), 10);
        this.loadAMap(()=>{
            this.loadAMapUI();
        });
    }
    loadAMap = (callback)=>{
        let AMap = window.AMap;
        if (AMap){
            this.execMap(callback);
            return;
        }
        
        let interval = setInterval(()=>{
            let AMap = window.AMap;
            if (AMap){
                clearInterval(interval);
                this.execMap(callback);
            }
        }, 300);
    }
    loadAMapUI = ()=>{
        let AMapUI = window.AMapUI;
        if (AMapUI){
            this.execAMapUI();
            return;
        }
        let interval = setInterval(()=>{
            let AMapUI = window.AMapUI;
            if (AMapUI){
                clearInterval(interval);
                this.execAMapUI();
            }
        }, 300)
    }
    execAMapUI = ()=>{
        let AMapUI = window.AMapUI;
        let is_sign_in= this.props.is_sign_in; 
        AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
          let AMap = window.AMap;
          let map = new AMap.Map('near-location', {
              zoom: 13
          })
          let positionPicker = new PositionPicker({
              mode: 'dragMap',//设定为拖拽地图模式，可选'dragMap'、'dragMarker'，默认为'dragMap'
              map: map//依赖地图对象
          });
          
          map.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
              // 是否使用高精度定位，默认：true
              enableHighAccuracy: true,
              // 设置定位超时时间，默认：无穷大
              timeout: 10000
            })

            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', (data) => {
              let { lng, lat } = data.position;
              positionPicker.start([lng, lat]);
              if (is_sign_in) {
                  positionPicker.stop();
                  let marker = new AMap.Marker({
                      icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                    position: [lng, lat],
                  });
                  marker.setMap(map);
              };
            })
            AMap.event.addListener(geolocation, 'error', (data) => {
              positionPicker.start();
              is_sign_in && positionPicker.stop();
            })

          })

          positionPicker.on('success', (result) => {
              let position = result.position;
              let placeSearch = this.placeSearch;
              placeSearch && placeSearch.searchNearBy('', [position.lng, position.lat], 3000, (status, result) => {
                  if (status === 'complete') {
                      Toast.hide();
                      this.setState({
                          nearList: result.poiList.pois
                      });
                  }else {
                      Toast.info($st('定位失败'), 1.5);
                  }
              });
          });
          this.positionPicker = this.positionPicker;
        });
    }
    execMap = (callback)=>{
        let AMap = window.AMap;
        AMap.service('AMap.PlaceSearch', () => {
            // center
            let placeSearch = new AMap.PlaceSearch({
                pageSize: 20,
                extensions: 'all',
                type: $st('公司企业|商务住宅|政府机构及社会团体')
            });
            this.placeSearch = placeSearch;
        })
        AMap.plugin('AMap.Autocomplete', () => {//回调函数
            //实例化Autocomplete
            var autoOptions = {
                city: "" //城市，默认全国
            };
            let autocomplete = new AMap.Autocomplete(autoOptions);
            this.autocomplete = autocomplete;
            //TODO: 使用autocomplete对象调用相关功能
        });
        this.setState({
            amapAvailable: true
        });
        callback && callback();
    }
    onClose = ()=>{
        let onSelect = this.props.onSelect;
        onSelect && onSelect();
    }
    onChangeSearch = (value)=>{
        //搜索
        this.setState({
            searchValue: value
        });
        
        if (this.searchTimer){
            clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(()=>{
            //开始搜索
            this.searchTimer = null;
            if (!value){
                this.setState({
                    searchList: []
                });
                return;
            }
            
            let autocomplete = this.autocomplete;
            autocomplete && autocomplete.search(value, (status, result)=>{
                if ('complete' === status ){
                    // 过滤
                    let tips = result.tips;
                    tips = tips.filter((tip)=>{
                        return !!tip.location;
                    });
                    //渲染列表
                    this.setState({
                        searchList: tips
                    })
                }else {
                    Toast.info($st('定位失败'), 1.5);
                }
            });
            
        }, 300);
    }
    onSelectItem = (pois)=>{
        let onSelect = this.props.onSelect;
        onSelect && onSelect(pois);
    }
    render(){
        let {nearList = [], searchValue, searchList = []} = this.state;
        let modalProps = {
            visible: true,
            closable: false
        }
        let listStyle = {};
        if (searchValue){
            listStyle.top = 60;
        }
        let dataSource = searchValue ? searchList : nearList;

        // <svg xmlns="http://www.w3.org/2000/svg" className="result-svg" viewBox="0 0 70 70">
        //     <path d="M639.297829 382.7712c-17.2032-17.173943-37.829486-30.954057-60.328229-40.257829-22.498743-9.303771-46.811429-14.1312-71.153371-14.1312-24.341943 0-48.683886 4.827429-71.153371 14.1312-22.498743 9.303771-43.125029 23.054629-60.328229 40.257829-17.2032 17.173943-30.983314 37.800229-40.316343 60.240457-9.303771 22.469486-14.160457 46.752914-14.160457 71.0656 0 24.312686 4.827429 48.596114 14.160457 71.0656 9.303771 22.469486 23.083886 43.066514 40.316343 60.240457 17.2032 17.173943 37.829486 30.954057 60.328229 40.257829 22.469486 9.303771 46.811429 14.1312 71.153371 14.1312 24.341943 0 48.654629-4.827429 71.153371-14.1312 22.469486-9.303771 43.125029-23.054629 60.328229-40.257829 17.2032-17.173943 30.983314-37.770971 40.287086-60.240457 9.303771-22.440229 14.160457-46.752914 14.160457-71.0656 0-24.312686-4.856686-48.596114-14.160457-71.0656C670.3104 420.571429 656.530286 399.9744 639.297829 382.7712zM918.557257 467.529143c-16.647314-199.533714-162.962286-348.3648-362.788571-362.203429L555.768686 0l-85.4016 0 0 106.7008C276.128914 124.693943 122.090057 272.149943 105.442743 467.529143L0 467.529143l0 87.127771 105.442743 0c16.647314 195.3792 168.842971 343.2448 363.081143 362.642286L468.523886 1024l87.215543 0 0-105.325714c199.797029-13.867886 346.141257-164.512914 362.788571-364.046629L1024 554.627657 1024 467.529143 918.557257 467.529143zM512 847.082057c-184.5248 0-334.848-151.464229-334.848-334.379886 0-182.915657 151.698286-336.223086 334.848-336.223086 184.554057 0 334.848 153.307429 334.848 336.223086C846.848 695.588571 696.5248 847.082057 512 847.082057z" p-id="5113" data-spm-anchor-id="0.0.0.i0.6b8e1c4esENwgD"></path>
        // </svg>
        return (
            <Modal className="near-modal" {...modalProps}>
                <div className="near__exit" onClick={this.onClose}>
                    <Icon type="left" />
                </div>
                {!this.props.is_sign_in && <div className="near__search">
                    <InputItem name="near-search" onChange={this.onChangeSearch} value={searchValue} placeholder={$st('搜索附近地址')} />
                </div>
                }
                <div className="near__location" id="near-location"></div>
                <div className="near__locate" onClick={this.onRefresh.bind(this)}>
                    <img alt='' className='icon' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Rjk1RURGMkQxRDQxMTFFOEFGODREMTBBMTczQkRFNjUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Rjk1RURGMkUxRDQxMTFFOEFGODREMTBBMTczQkRFNjUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGOTVFREYyQjFENDExMUU4QUY4NEQxMEExNzNCREU2NSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGOTVFREYyQzFENDExMUU4QUY4NEQxMEExNzNCREU2NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlurgrYAAAGbSURBVHjapNNNKERRFMBxM00mMkr5aERKkjLDShlFSbGQlLHWoKxsWLCxsLVAmTVlS5nEwkI+hiKlWIiRWUkS5WOYDJPxP9N5uljOrV/3de89591z73u2VCqVlUlzlAYTvwbcMWch3Si6UK3Dl1jDDB5koCYylJ6w/wn200Uxjifc4B6PGNM5vxljN4J76Jb1bV40YxLTaEEdIrrmJ4nNPfcuwUU8X+ECrYjrfA6cuhtpudiWClBFGTFrB8PIw4ARbEM9PMZO47pG1o5IImuiG+FbV+LMCA7hAHvYlAPXOVkTRifKrQSyJS+lTNAXo1GTWk3KateS+lGBSuTb9W3SPnWLCX3+2z6QxJv22dYt2PXwopQg9/yMY2wYwfvY0cRLuNMbebESrMJHCR4NSGmNbejQEpI6V4smrOPaKiGIV8zrVUn7whFOjGCZW9C1szhPHyJbl88zgAZs6dVJ68Og8eZdXRPgG5AvNOHQw5EkIf2UF3GKQ5TpYUk5Pj3AXr3i//+CJNEfaAoulKBArkvHZG7FjLFl+jt/CzAAw8R0xTZ/l/cAAAAASUVORK5CYII=' />
                </div>
                <div className='near-location'>
                    <div className='near-signin'>
                        <img alt='' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAAHnMM+TAAAAAXNSR0IArs4c6QAAAW9JREFUKBVtUD0sQ1EUPue+12AoJUKCtsJq6MRai4VJxCTpwmJoQttEa9BB+hJeCAkLC7Ew6C4Ss0kkpAOGtro08Vva4fW9454rr9HEGc695/u+c853L8DfiBeMI5CpJIioD2N54wmAhhoSSa1ygfFiZowIViCWz9BX/ZsEw2ulHT5+AxPPGyHHrt80AIS6INteZyDaG1G4HKIj3+JFI0wOXaFUmYGUR4GxQiaLgKOANG36U9cYL2QsblG9MumaCOkMDLYMgOVY4NPb4b72eK78lK0X6PZ0SeAB5LycQMTjqlOD22pOTTCDySlhBpIR3soIChxXjJvcFyuSk3x5lAi3gEhzRepEtBFpWdrcZZun0tVsk0AW7HKyIwx75ROQK8/Y+oQrWuyZgw/7E4Zbg5B9vVAi5lija5o2Y9v2JQP7svu/YI36tvTbtq9Sqd0BQX+TEKHk9baNpDuX3pXQJRNFY95x6IBrIXBh0588dLkf/5GROfeb77sAAAAASUVORK5CYII=' />
                        <div className='title'>{$st("附近地址")}</div>
                    </div>
                </div>
                <List className="near__list" style={listStyle}>
                    {
                        dataSource.map((pois)=>{
                            return (
                                <List.Item key={pois.id} onClick={()=>{this.onSelectItem(pois)}}>
                                    {`${pois.name}`}
                                    <Brief>{pois.district || ''}{pois.pname}{pois.cityname || ''}{pois.adname || ''}{pois.address}</Brief>
                                </List.Item>
                            )
                        })
                    }
                </List>
            </Modal>
        )
    }
    
}
export default NearLocation;



// WEBPACK FOOTER //
// ./src/component/Location/NearModal.js